import { useState, useEffect } from 'react'
import { HiLocationMarker } from 'react-icons/hi'
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaTiktok, FaTumblr, FaDiscord } from 'react-icons/fa'
import SocialBtn from '../../components/socialbtn/SocialBtn' 
import UserAppContext from '../../hook/UserAppContext'

const ContentBanner = () => {

      const {user, data} = UserAppContext()
      const [online, setOnline] = useState([])
      const {banners, infordata, social} = user.user 
      const id_user = infordata.data || infordata.id_xat === '' ? 0 : infordata.id_xat
      const name = infordata.data || infordata.name === '' ? data.info.name : infordata.name
      const avatar = infordata.data || infordata.avatar === '' ? data.info.avatar : infordata.avatar
      const status = infordata.data || infordata.status === '' ? data.info.status : infordata.status
      const about = infordata.data || infordata.about === '' ? data.info.about : infordata.about
      const location = infordata.data || infordata.location === '' ? data.info.location : infordata.location
      const id_xat = infordata.data || infordata.id_xat === '' ? data.info.id_xat : infordata.id_xat

      async function getOnline (id){

            try{
                  const response = await fetch(`https://oceanbot.net/online.php?id=${id}`)
                  const result = await response.json()
                  setOnline(result)
            }catch(err){
                  console.log('Error: ', err)
            }
      }

      useEffect(() => {
            getOnline(id_user)
      }, [id_user])

      return (
            <div className="content_banner">
                  <div className="banner_img">
                        <img src={banners.data ? data.banner.image : banners[0].image} alt={banners.data ? data.banner.title : banners[0].title} />
                  </div>
                  <div className="wrapper_user">
                        <div className="user_avatar">
                              <img src={avatar} alt={name} />
                              <div className={online.status === "online" ? "dots green" : "dots red"}></div>
                        </div>
                        <div className="user_data">
                              <div className="online_box">
                                    <span>{online.status === "online" ? "Online Now" : "Offline"}</span>
                              </div>
                              <h1>{name}</h1>
                              <p>{status}</p>
                        </div>
                        <div className="user_id">
                              <h2>{id_xat}</h2>
                        </div>
                  </div>
                  
                  <div className="content_banner__footer">
                        <div className="wrapper_social">
                              <div className="social_menu">
                                    <SocialBtn link={social.facebook} icon={<FaFacebookF/>}/>
                                    <SocialBtn link={social.twitter} icon={<FaTwitter/>}/>
                                    <SocialBtn link={social.instagram} icon={<FaInstagram/>}/>
                                    <SocialBtn link={social.youtube} icon={<FaYoutube/>}/>
                                    <SocialBtn link={social.tiktok} icon={<FaTiktok/>}/>
                                    <SocialBtn link={social.tumblr} icon={<FaTumblr/>}/>
                                    <SocialBtn link={social.discord} icon={<FaDiscord/>}/>
                              </div>
                        </div>
                        <div className="description_user">
                              <p>{about}</p>
                        </div>
                        <div className="location">
                              <div className="location_icon"><HiLocationMarker /></div>
                              <span>{location}</span>
                        </div>
                  </div>
            </div>
      )
}

export default ContentBanner
